import { render, staticRenderFns } from "./RulePopup.vue?vue&type=template&id=b52a26e8&scoped=true"
import script from "./RulePopup.vue?vue&type=script&lang=js"
export * from "./RulePopup.vue?vue&type=script&lang=js"
import style0 from "./RulePopup.vue?vue&type=style&index=0&id=b52a26e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52a26e8",
  null
  
)

export default component.exports